import {
  DeleteFilled,
  DownloadOutlined,
  DownOutlined,
  EditOutlined,
  MailOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Pagination,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tooltip,
  theme,
} from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import moment from "moment";
import Heading from "../../../components/common/heading";
import NotFound from "../../../components/common/notFound";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import { ERR_0017, SUCCESS_CODE } from "../../../lib/const";
import useEState from "../../../lib/hooks/useEState";
import useLineOfWork from "../../../lib/hooks/useLineOfWork";
import useRole from "../../../lib/hooks/useRole";
import { resendEmail, updateProfile } from "../../../services/profileService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  deleteUser,
  searchUserLoginReport,
} from "../../../services/userManagement";
import ActionModal from "./actionModal";
import { SearchReportContext } from "./searchContext";
import {MultipleAutoComplete} from "../../../components/common/autoCompleteV2";

const Option = Select.Option;
const { useToken } = theme;


const Report = () => {
  // const navigate = useNavigate();

  const [searchForm] = Form.useForm();
  const { searchValues, setSearchValues, pageValues, setPageValues } =
    useContext(SearchReportContext);
  const { token } = useToken();
  const [estates] = useEState();
  const [lineOfWork] = useLineOfWork();
  const [roles] = useRole();
  const [dataSource, setDataSource] = useState([]);
  let [no, setNo] = useState(0);
  const [actionModal, setActionModal] = useState(false);
  const [actionTypeModal, setActionTypeModal] = useState("");
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState({});
  const [fetchData, setFetchData] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const [failModal, setFailModal] = useState(false);
  const [sentFail, setSentFail] = useState({
    title: "",
    subTitle: "",
  });

 const fetchAllUsersForExport = async () => {
  const exportPageValues = {
    ...pageValues,
    page: 0,
    pageSize: 500, // หรือค่าที่ backend รองรับ
  };

  const res = await searchUserLoginReport(
    {}, // ไม่เอา search
    exportPageValues
  );

  if (res?.data?.code === SUCCESS_CODE) {
      return res;
  }

  return [];
}; 
const exportToExcel =  async () => {

// const exportData = dataSource.map((item) => ({
//    ...item,
   
// }));
  const res =  await fetchAllUsersForExport();

 //console.log("return ws export =>");
 //console.log(res); 
 const exportData = Array.isArray(res?.data?.objectValue)
      ? res.data.objectValue
      : [];

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "LogsLogin");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, "LogsLogin.xlsx");
};

  const fetchUsers = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchUserLoginReport(searchValues, pageValues);
      console.log("user res", res);
      if (res?.data?.code === SUCCESS_CODE) {
        console.log("search user login=>");
        console.log(res.data);
 
        const { objectValue, pageValue } = res.data;
        setDataSource(objectValue);
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setPageValues({
          page: parseInt(pageValue.page),
          pageSize: parseInt(pageValue.pageSize),
          total: parseInt(pageValue.total),
          totalPage: parseInt(pageValue.totalPage),
          sortBy: pageValue.sortBy,
          sortDirection: pageValue.sortDirection,
        });
      } else {
        setDataSource([]);
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    },
    [setPageValues]
  );

  useEffect(() => {
    fetchUsers(searchValues, pageValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fetchUsers,
    searchValues,
    pageValues.page,
    pageValues.pageSize,
    pageValues.sortBy,
    pageValues.sortDirection,
    searchForm,
  ]);

  const handleStatusChange = async () => {
    const request = {
      userId: confirmModal?.id,
      accountStatus: confirmModal?.status === "A" ? "D" : "A",
      fromPage: "manage",
    };

    const res = await updateProfile(request);
    if (res?.data?.code === SUCCESS_CODE) {
      setFetchData(true);
    } else {
      setFailModal(true);
    }
    setConfirmModal({
      type: "",
      show: false,
      id: 0,
    });
  };

  const handleDeleteUser = async () => {
    const res = await deleteUser(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setFetchData(true);
    } else {
      setFailModal(true);
    }
    setConfirmModal({
      type: "",
      show: false,
      id: 0,
    });
  };

  useEffect(() => {
    if (fetchData) {
      setLoading(true);
      fetchUsers(searchValues, pageValues);
      setTimeout(() => {
        setSuccessModal(true);
        setFetchData(false);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, fetchUsers]);

  const onSearchForm = (values) => {
    setLoading(true);
    setSearchValues({
      username: values?.username || "",
      fullName: values?.fullName || "",
      estateId: values?.estateId || "",
      lineOfWorkId: values?.lineOfWorkId || "",
    });
  };

  const columns = [
    {
      width: 40,
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      key: "no",
      render: (_, record) => <span>{(no += 1)}</span>,
    },
    {
      width: 120,
      align: "center",
      title: "User ID",
      dataIndex: "userId",
      key: "userId",
      sorter: (a, b) => a.userId - b.userId,
    },
    {
      width: 150,
      title: "ชื่อผู้ใช้ระบบ",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => a.username - b.username,
    },
    {
      width: 200,
      title: "ชื่อจริง-นามสกุล",
      dataIndex: "fullName",
      key: "fullName",
      sorter: (a, b) => a.fullName - b.fullName,
    },
    {
      width: 200,
      title: "ชื่อนิคม",
      dataIndex: "estateNameTh",
      key: "estateId",
      sorter: (a, b) => a.estateId - b.estateId,
    },
    {
      width: 120,
      title: "สายงาน",
      dataIndex: "lineOfWorkNameTh",
      key: "lineOfWorkId",
      sorter: (a, b) => a.lineOfWorkId - b.lineOfWorkId,
    },
    {
      width: 250,
      title: "จำนวนการ Login",
      dataIndex: "countLogin",
      key: "countLogin",
      sorter: (a, b) => new Date(a.countLogin) - new Date(b.countLogin),
      // render: (e, record) => {
      //   const dateFormat = record.countLogin
      //     ? moment(record.countLogin).add(543, "year").format("DD/MM/YYYY HH:mm")
      //     : "";
      //   return <span>{dateFormat}</span>;
      // },
    },
    // {
    //   width: 120,
    //   title: "Role",
    //   dataIndex: "roleNameTh",
    //   key: "roleId",
    //   sorter: (a, b) => a.roleId - b.roleId,
    // },
    // {
    //   width: 120,
    //   align: "center",
    //   title: "สถานะ",
    //   dataIndex: "recStatus",
    //   key: "recStatus",
    //   sorter: (a, b) => a.recStatus - b.recStatus,
    //   render: (_, record) => (
    //     <Switch
    //       checked={record.recStatus === "A" ? true : false}
    //       onChange={() =>
    //         setConfirmModal({
    //           type: "change_status",
    //           show: true,
    //           id: record.userId,
    //           status: record.recStatus,
    //         })
    //       }
    //     />
    //   ),
    // },
    // {
    //   width: 120,
    //   align: "center",
    //   title: "การจัดการ",
    //   dataIndex: "management",
    //   key: "management",
    //   render: (_, record) => (
    //     <Space>
    //       {!record.isVerify && (
    //         <Tooltip placement="bottom" title={"Resend email"}>
    //           <Button
    //             style={{ backgroundColor: "#F4F6FC", border: 0 }}
    //             shape="circle"
    //             onClick={() => sendMailVerify(record.email)}
    //           >
    //             <MailOutlined style={{ color: "#2E90FA" }} />
    //           </Button>
    //         </Tooltip>
    //       )}

    //       <Tooltip placement="bottom" title={"แก้ไข"}>
    //         <Button
    //           style={{ backgroundColor: "#FEF1DF", border: 0 }}
    //           shape="circle"
    //           onClick={() => {
    //             setEditData(record);
    //             setActionModal(true);
    //           }}
    //         >
    //           <EditOutlined style={{ color: "#F79009" }} />
    //         </Button>
    //       </Tooltip>
    //       <Tooltip placement="bottom" title={"ลบ"}>
    //         <Button
    //           style={{ backgroundColor: "#FDE7E5", border: 0 }}
    //           shape="circle"
    //           onClick={() => {
    //             setConfirmModal({
    //               type: "delete",
    //               show: true,
    //               id: record.userId,
    //             });
    //           }}
    //         >
    //           <DeleteFilled style={{ color: "#F04438" }} />
    //         </Button>
    //       </Tooltip>
    //     </Space>
    //   ),
    // },
  ];

  const onSorter = (pagination, filters, sorter) => {
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "userId",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setLoading(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  const clearSearchValues = () => {
    setLoading(true);
    searchForm.resetFields();
    setSearchValues({
      username: "",
      fullName: "",
      estateId: "",
      lineOfWorkId: "",
    });
    setPageValues({
      page: 0,
      pageSize: 10,
      sortBy: "userId",
      sortDirection: "ASC",
    });
  };

  const sendMailVerify = async (email) => {
    // let e = "ieat_ddm2@yopmail.com";
    const res = await resendEmail(email);
    if (res?.data.code === SUCCESS_CODE) {
      setFetchData(true);
    } else {
      if (res?.data.code === ERR_0017) {
        setSentFail({
          title: "ไม่สามารถทำรายการได้ในขณะนี้",
          subTitle: "โปรดทำรายการใหม่อีกครั้งภายหลัง",
        });
      } else {
        setSentFail({
          title: "",
          subTitle: "",
        });
      }
      setFailModal(true);
    }
  };

  return (
    <div className="user_management" style={{ minHeight: "100vh" }}>
      <div className="flex justify-between items-center">
        <Heading text={"รายงานการเข้าใช้ระบบ"} size={4} />
        <div>
          <Button
            type="primary"
           onClick={exportToExcel}
          >
            <DownloadOutlined /> Export Excel
          </Button>
        </div>
      </div>
      <div className="card">
        <Form form={searchForm} onFinish={onSearchForm}>
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item label="" name="username">
                <Input
                  prefix={<SearchOutlined />}
                  placeholder="ชื่อผู้ใช้งานระบบ"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="" name="fullName">
                <Input placeholder="ชื่อจริง - นามสกุล" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="" name="estateId">
                {/* <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="ชื่อนิคม"
                >
                  {estates.map((item) => (
                    <Option value={item.estateId}>{item.estateNameTh}</Option>
                  ))}
                </Select> */}
                <MultipleAutoComplete
                  multiple={false}
                  subject="estateName"
                  valueField="estateId"
                  labelField="estateNameTh"
                  placeholder="ชื่อนิคม"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={"lineOfWorkId"}>
                <Select
                  allowClear
                  // defaultValue="lucy"
                  style={{
                    width: "100%",
                  }}
                  placeholder="สายงาน"
                >
                  {lineOfWork.map((item) => (
                    <Option value={item.lineOfWork}>{item.nameTh}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} align="right">
              <Space>
                <Button onClick={clearSearchValues}>ล้างข้อมูล</Button>
                <Button type="primary" htmlType="submit">
                  ค้นหา
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>

      <div className="list_table" style={{ marginTop: 30, marginBottom: 80 }}>
        <Row gutter={[24, 12]}>
          <Col span={24}>
            รายการทั้งหมด{" "}
            <span style={{ color: token.thPrimary, fontWeight: 700 }}>
              {pageValues?.total}
            </span>{" "}
            รายการ
          </Col>
          <Col span={24}>
            <Table
              locale={{ emptyText: <NotFound /> }}
              loading={loading}
              rowKey={"key"}
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              scroll={{
                x: 1301,
              }}
              onChange={onSorter}
            />
          </Col>
          <Col span={24} align="right">
            <Pagination
              showSizeChanger
              defaultCurrent={pageValues.page + 1 || 1}
              total={pageValues.total || 10}
              onChange={onPageChange}
              showTotal={(total) => `รวม ${total} รายการ`}
            />
          </Col>
        </Row>
      </div>

      <ActionModal
        open={actionModal}
        setOpen={setActionModal}
        actionTypeModal={actionTypeModal}
        setActionTypeModal={setActionTypeModal}
        estates={estates}
        lineOfWork={lineOfWork}
        roles={roles}
        editData={editData}
        setEditData={setEditData}
        setFetchData={setFetchData}
      />

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDeleteUser();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />

      <ConfirmModal
        actionType={""}
        title={"ยืนยันการเปลี่ยนสถานะ"}
        modalText={`คุณต้องการเปลี่ยนสถานะเป็น  ${
          confirmModal.status === "A" ? "“ระงับการใช้งาน”" : "“กำลังใช้งาน”"
        } ใช่ไหม ?`}
        open={confirmModal.type === "change_status" ? confirmModal.show : false}
        onOk={() => {
          handleStatusChange();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />

      <FailModal
        open={failModal}
        setOpen={setFailModal}
        title={sentFail.title}
        subTitle={sentFail.subTitle}
      />
    </div>
  );
};

export default Report;
